import { iAvailableLanguages } from './types'

export type iGetMostlyAppropiateLangCode = (
  userLang: string | null,
  availableLanguages: iAvailableLanguages,
) => string

const getMostlyAppropiateLangCode: iGetMostlyAppropiateLangCode = (
  userLang,
  availableLanguages,
) => {
  const defaultLang =
    availableLanguages[availableLanguages.default.default].default
  if (!userLang) return defaultLang

  const language = userLang.slice(0, 2)
  if (!availableLanguages[language]) return defaultLang

  let languageSelected = availableLanguages[language].default

  const availables = availableLanguages[language].availables
  if (availables !== undefined) {
    availables.forEach((match) => {
      if (match.toLowerCase() === userLang.toLowerCase())
        languageSelected = match
    })
  }

  return languageSelected
}

export { getMostlyAppropiateLangCode }
